import React from 'react'
import { Form } from 'react-final-form'
import type {
  ServiceRegistryFormData,
  ServiceRegistryFormValidationErrors,
} from '@/app/registry/service-registry/_hooks/use-service-form-validation'
import { ServiceOAuthCallbackData } from '../_hooks/use-service-oauth-callback'
import { SERVICE_TYPES } from '../_utils/constants'

export type ServiceRegistryFormProps = {
  initialFormData?: Partial<ServiceRegistryFormData>
  onSubmit: (formData: ServiceRegistryFormData) => Promise<void>
  children: (renderProps: ServiceRegistryFormRenderProps) => React.ReactNode
  validateDialogForm: (formData: ServiceRegistryFormData) => ServiceRegistryFormValidationErrors
  oauthCallbackData?: ServiceOAuthCallbackData
}

export type ServiceRegistryFormRenderProps = {
  handleSubmit?: () => void
  isFormValid?: boolean
  formData?: Partial<ServiceRegistryFormData>
}

export function ServiceRegistryForm({
  initialFormData,
  onSubmit,
  validateDialogForm,
  oauthCallbackData,
  children,
}: ServiceRegistryFormProps) {
  return (
    <Form<ServiceRegistryFormData>
      initialValues={initialFormData}
      onSubmit={onSubmit}
      validate={validateDialogForm}
      render={({ handleSubmit, valid, values: formData, form: formApi }) => {
        const selectedServiceType = formData?.serviceType

        // Update form with OAuth callback data when available
        React.useEffect(() => {
          if (
            oauthCallbackData?.formData &&
            Object.values(oauthCallbackData.formData).some((v: string) => v?.length > 0)
          ) {
            const { name, url, serviceType, key } = oauthCallbackData.formData
            formApi.change('name', name)
            formApi.change('url', url)
            formApi.change('serviceType', serviceType)
            formApi.change('key', key)
          }
        }, [oauthCallbackData?.formData])

        // Clear API key when switching to OAuth service type
        React.useEffect(() => {
          if (selectedServiceType === SERVICE_TYPES.MCP_OAUTH2 && formData?.key) {
            formApi.change('key', '')
          }
        }, [selectedServiceType])

        return children({ formData, handleSubmit, isFormValid: valid })
      }}
    />
  )
}
